import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { PinterestLayout, socialConnectionsQueryOptions } from '@/features/social';

/** Social › Pinterest: the secondary sidebar around every Pinterest page. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest')({
  staticData: { crumb: 'social:pinterest.name' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'social.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...socialConnectionsQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: PinterestLayout,
});
